import { useState, useEffect } from "react"
import { ShowMessage } from "../alert"
import { useApp } from "../AppProvider"
import { mainApi } from "../api"
import { useParams } from "react-router-dom"
const Auth = () => {
    const { login } = useApp();
    const { id } = useParams();
    const [registerFirstChars, setRegisterFirstChars] = useState("****");
    const [registerLastChars, setRegisterLastChars] = useState("");


    const getRegister = async () => {
        let data = JSON.stringify({
            "barcode": id
        });
        try {
            const response = await mainApi({ url: "/police/getRegister", data });
            console.log("RESONSE IN AUTH getRegister", response);
            if (!response.success)
                ShowMessage(response.message)
            if (!response.data)
                ShowMessage(`${id} дугаартай торгуулийн мэдээлэл олдсонгүй!`)

            setRegisterFirstChars("*" + response && response.data && response.data.REGISTER)
        }
        catch (error) {
            ShowMessage(error)
        }
    }
    const checkRegister = async () => {
        let data = {
            "barcode": id, registerFirstChars, registerLastChars
        };
        try {
            const response = await mainApi({ url: "/police/checkRegister", data });
            console.log("RESONSE IN AUTH checkRegister", response);

            if (response.token) {
                login(response, id)
            }
            else {
                ShowMessage("Регистрийн дугаар буруу байна");
                setRegisterLastChars("");
            }
        }
        catch (error) {
            ShowMessage(error)
        }
    }
    useEffect(() => {
        getRegister();
    }, []);

    return (
        <div className="container mx-auto p-4">
            <div className="flex justify-center items-center">
                <div className=" items-center content-center text-center max-w-40">
                    <h2 className="text-lg mb-4 text-center">Регистрийн дугаарын сүүлийн 4 оронг оруулж баталгаажуулна уу.</h2>

                    <div className="w-full">
                        <p className="fmb-4 text-center mb-4">{registerFirstChars} {registerLastChars}</p>
                        <input type="text" id="first_name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 max-w" placeholder="Сүүлийн 4 оронг нөхөж бичнэ үү" required value={registerLastChars} onChange={e => setRegisterLastChars(e.target.value)} maxLength={4} />
                    </div>
                    <div className="mt-4 text-center max-w-80">
                        <button
                            onClick={checkRegister}
                            className="bg-blue-500 text-white px-4 py-2 mr-2 rounded hover:bg-blue-600"
                        >
                            Шалгах
                        </button>
                    </div>
                </div>


            </div>

        </div>
    );
};

export default Auth